import { render, staticRenderFns } from "./IseqDatafield.vue?vue&type=template&id=ba996220&scoped=true"
import script from "./IseqDatafield.vue?vue&type=script&lang=js"
export * from "./IseqDatafield.vue?vue&type=script&lang=js"
import style0 from "./IseqDatafield.vue?vue&type=style&index=0&id=ba996220&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba996220",
  null
  
)

export default component.exports